/**
 * 非通用型选择器增强装饰器
 * @returns {(function(*, *, *): void)|*}
 * @constructor
 */
function MultipleChoiceEnhancement() {
    return function (target, name, descriptor) {
        const fn = descriptor.value
        descriptor.value = function (...rest) {
            let selectList = this.multipleSelection
            fn.call(this, ...rest)
            this.tableList.sTMaterialsList.filter(v => selectList.includes(v.checkFrontId)).forEach(v => {
                setTimeout(() => {
                    this.$refs.sTMaterialsList.toggleRowSelection(v, true)
                })
            })
        }
    }
}

/**
 * 日志打印
 * @param type {String} - development|test|production
 * production>test>development 默认为test可不写
 * @returns {(function(*, *, *): void)|*}
 * @constructor
 */
function Log(type = "test") {
    //时间格式化
    function time(dataStr) {
        let date = new Date(dataStr);
        let y = date.getFullYear();

        let m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;

        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;

        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;

        //获得分
        let mm = date.getMinutes()
        mm = mm < 10 ? ('0' + mm) : mm;

        //获得秒
        let ss = date.getSeconds()
        ss = ss < 10 ? ('0' + ss) : ss;
        // console.log(y+'-'+m+'-'+d+' '+h+':'+mm+':'+ss)
        return y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + ss

    }

    return function (target, name, descriptor) {
        const List = ["development", "test", "production"]
        const fn = descriptor.value
        descriptor.value = function (...rest) {
            const log = console.log
            if (List.includes(type)) {
                if (List.indexOf(process.env.NODE_ENV.toString()) <= List.indexOf(type)) {
                    console.log = log.bind(this, `%c[${time(new Date())}] [INFO] ${type === "test" ? "DEFAULT" : type.toUpperCase()} -`, "color:blue");
                } else {
                    console.log = function () {}
                }
            } else {
                console.error()
            }
            fn.call(this, ...rest)
            console.log = log
        }

    }
}

/**
 * 请求参数
 * @param url {String} - URL
 * @param method {String} - Method
 * @param option {Object} - Option
 * @returns {(function(*, *, *): void)|*}
 * @constructor
 */
function Http(url, method, option = {}) {
    return function (target, name, descriptor) {
        const fn = descriptor.value

        descriptor.value = function (...rest) {

            function callback(data, param = "") {
                let obj = {...option}
                obj.url = url + (param ? "?" + param : "")
                obj.method = method
                if (method.toUpperCase() === "GET") {
                    obj.params = data
                } else {
                    obj.data = data
                }
                return this.$http(obj)
            }

            fn.call(this, callback.bind(this), ...rest)
        }
    }
}

/**
 * 模版下载
 * @param url
 * @param method
 * @param fileName
 * @returns {(function(*, *, *): void)|*}
 * @constructor
 */
function Download(url, method, fileName) {
    return function (target, name, descriptor) {
        const fn = descriptor.value

        descriptor.value = function (...rest) {

            function callback(data, param = "") {
                let obj = {
                    responseType: "blob"
                }
                obj.url = url + (param ? "?" + param : "")
                obj.method = method
                if (method.toUpperCase() === "GET") {
                    obj.params = data
                } else {
                    obj.data = data
                }
                return this.$http(obj).then(async (res) => {
                    if (res.status === 200) {
                        try {
                            let blobText = new Blob([res.data], {
                                type: "application/json",
                            }); // 文件流
                            let response = JSON.parse(await blobText.text())
                            if (response.success === false) {
                                return Promise.reject(response.msg)
                            }
                        } catch (e) {
                            let blob = new Blob([res.data], {
                                type: "application/vnd.ms-excel",
                            }); // 文件流
                            let blobUrl = URL.createObjectURL(blob);
                            const link = document.createElement("a"); //模拟a链接，不支持低版本ie
                            link.download = fileName;
                            link.style.display = "none";
                            link.href = blobUrl;
                            document.body.appendChild(link);
                            link.click();
                            URL.revokeObjectURL(link.href);
                            document.body.removeChild(link);
                            return Promise.resolve()
                        }
                    }
                }).catch((err) => {
                    return Promise.reject(err)
                });
            }

            fn.call(this, callback.bind(this), ...rest)
        }
    }
}

export {
    MultipleChoiceEnhancement,
    Log,
    Http,
    Download
}
